import Title from "./banner/Title";
import Description from "./banner/Description";
import Buttons from "./banner/Buttons";
import { motion } from "framer-motion";

export default function Banner() {
  return (
    <div className="banner-wrapper section">
      <motion.div
        className="banner flex"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.2 }}
      >
        <Title />
        <Description />
        <Buttons />
      </motion.div>
    </div>
  );
}
